import Vue from 'vue'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import VueLazyLoad from 'vue-lazyload'
import 'swiper/dist/css/swiper.css'
import PortalVue from 'portal-vue'
import VueSticky from 'vue-sticky'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Toast from '@/common/plugins/Toast'
import { addFaceBookLog, addGoogleAnalytics, addNaverLog } from '@/common/plugins/sns.lib'
import VueClipBoard from 'vue-clipboard2'
import axiosCancel from 'axios-cancel'
import VModal from 'vue-js-modal'
import VueMeta from 'vue-meta/lib/vue-meta.min'
import { addAppsflyer, addWavveLoggerLib } from '@/common/plugins/appsflyer.lib'
import { getGUID, setGUID, setIp } from '@/common/util/common'
import { getGuidIssue, getIp } from '@/common/api/api.service'
import _ from 'lodash'

const Plugin = {
  init () {
    axiosCancel(axios, { debug: true })
    Vue.prototype.$events = new Vue()
    Vue.use(VueAxios, axios)
    Vue.use(VueLazyLoad, { lazyComponent: true,
      preLoad: 2,
      observer: true,
      observerOptions: {
        rootMargin: '0px',
        threshold: 0.1
      } })
    Vue.use(VueAwesomeSwiper)
    Vue.use(VueSticky)
    Vue.use(PortalVue)
    Vue.use(Toast)
    Vue.use(VueClipBoard)
    Vue.use(VueMeta, { keyName: 'metaInfo',
      attribute: 'data-vue-meta',
      ssrAttribute: 'data-vue-meta-server-rendered',
      tagIDKeyName: 'vmid',
      refreshOnceOnNavigation: true })
    Vue.use(VModal, { dynamic: true, injectModalsContainer: true })
    let dc = document.getElementsByTagName('head')[0]
    if (!dc) { console.warn('no head tag') }
    addGoogleAnalytics(dc)
    addNaverLog(dc)
    addFaceBookLog(dc)
    addAppsflyer()
    addWavveLoggerLib()

    getIp().then(({ data }) => { setIp(_.get(data, 'ip', '')) })

    if (getGUID() === '') {
      getGuidIssue().then(({ data }) => { setGUID(data) })
    }
  }
}

export default Plugin
